import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react';

import authReducer from './slice/authSlice';
import authapi from './services/authAPI';
import candidateAPI from './services/candidateAPI';
import candidateInteractionAPI from './services/candidateInteractionAPI';
import channelAPI from './services/channelApi';
import jobTitleAPI from './services/jobTitleAPI';
import departmentAPI from './services/departmentAPI';
import positionAPI from './services/positionAPI';
import rejectedReasonAPI from './services/rejectedReasonAPI';
import reportsAPI from './services/reportsAPI';
import skillAPI from './services/skillAPI';
import sourceAPI from './services/sourceAPI';
import userAPI from './services/userAPI';
import emailAPI from './services/emailAPI';
import valueAPI from './services/valueAPI';
import interviewAPI from './services/interviewAPI';
import interviewTypeAPI from './services/interviewTypeAPI';
import ssoAPI from './services/ssoAPI';
import questionAPI from './services/questionAPI';
import questionaryAPI from './services/questionaryAPI';
import securityRoleAPI from './services/securityRoleAPI';
import rolesMappingAPI from './services/rolesMappingAPI';
import securityPermissionsAPI from './services/securityPermissionsAPI';
import systemActionAPI from './services/systemActionAPI';
import skillCategoriesAPI from './services/skillCategoriesAPI';
import mainSkillCategoriesAPI from './services/mainSkillCategoriesAPI';
import subSkillAPI from './services/subSkillAPI';
import processStatusAPI from './services/processStatusAPI';
import followupReasonAPI from './services/followupReasonAPI';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authapi.reducerPath]: authapi.reducer,
    [ssoAPI.reducerPath]: ssoAPI.reducer,
    [candidateAPI.reducerPath]: candidateAPI.reducer,
    [candidateInteractionAPI.reducerPath]: candidateInteractionAPI.reducer,
    [channelAPI.reducerPath]: channelAPI.reducer,
    [jobTitleAPI.reducerPath]: jobTitleAPI.reducer,
    [departmentAPI.reducerPath]: departmentAPI.reducer,
    [positionAPI.reducerPath]: positionAPI.reducer,
    [rejectedReasonAPI.reducerPath]: rejectedReasonAPI.reducer,
    [reportsAPI.reducerPath]: reportsAPI.reducer,
    [skillAPI.reducerPath]: skillAPI.reducer,
    [sourceAPI.reducerPath]: sourceAPI.reducer,
    [interviewAPI.reducerPath]: interviewAPI.reducer,
    [interviewTypeAPI.reducerPath]: interviewTypeAPI.reducer,
    [userAPI.reducerPath]: userAPI.reducer,
    [emailAPI.reducerPath]: emailAPI.reducer,
    [valueAPI.reducerPath]: valueAPI.reducer,
    [questionAPI.reducerPath]: questionAPI.reducer,
    [questionaryAPI.reducerPath]: questionaryAPI.reducer,
    [securityRoleAPI.reducerPath]: securityRoleAPI.reducer,
    [rolesMappingAPI.reducerPath]: rolesMappingAPI.reducer,
    [securityPermissionsAPI.reducerPath]: securityPermissionsAPI.reducer,
    [systemActionAPI.reducerPath]: systemActionAPI.reducer,
    [skillCategoriesAPI.reducerPath]:skillCategoriesAPI.reducer,
    [mainSkillCategoriesAPI.reducerPath]: mainSkillCategoriesAPI.reducer,
    [subSkillAPI.reducerPath]:subSkillAPI.reducer,
    [processStatusAPI.reducerPath]:processStatusAPI.reducer,
    [followupReasonAPI.reducerPath]:followupReasonAPI.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
    authapi.middleware,
    ssoAPI.middleware,
    candidateAPI.middleware,
    candidateInteractionAPI.middleware,
    channelAPI.middleware,
    jobTitleAPI.middleware,
    departmentAPI.middleware,
    positionAPI.middleware,
    rejectedReasonAPI.middleware,
    reportsAPI.middleware,
    sourceAPI.middleware,
    interviewAPI.middleware,
    interviewTypeAPI.middleware,
    skillAPI.middleware,
    userAPI.middleware,
    emailAPI.middleware,
    valueAPI.middleware,
    questionAPI.middleware,
    questionaryAPI.middleware,
    securityRoleAPI.middleware,
    rolesMappingAPI.middleware,
    securityPermissionsAPI.middleware,
    systemActionAPI.middleware,
    skillCategoriesAPI.middleware,
    mainSkillCategoriesAPI.middleware,
    subSkillAPI.middleware,
    processStatusAPI.middleware,
    followupReasonAPI.middleware
  ),

})
setupListeners(store.dispatch);